/** 超级会员提现环节挽留弹窗曝光 */
export const financeLoanPackageEntryRetainPopupExpose = 'finance_loan_packageEntry_RetainPopup';

/** 超级会员提现环节挽留勾选协议按钮 */
export const financeLoanPackageEntryRetainPopupAgreementCheck = 'finance_loan_packageEntry_RetainPopup_agreementCheck';

/** 超级会员提现环节挽留弹窗底部按钮 */
export const financeLoanPackageEntryRetainPopupBottomButton = 'finance_loan_packageEntry_RetainPopup_BottomButton';

/** 超级会员提现环节挽留弹窗协议 */
export const financeLoanPackageEntryRetainPopupAgreement = 'finance_loan_packageEntry_RetainPopup_agreement';
